import React from 'react'

const Badge = ({ badgeColor, percentage }) => (
  <span className={`admin-dashboard-stats__badge badge ${badgeColor} p-2`}>
    {percentage && `${percentage}%`}
  </span>
)

export default Badge
